<template>     
   <section class="breadcrumbs-custom">            
      <div class="breadcrumbs-custom-footer">
        <div class="container">
          <ul class="breadcrumbs-custom-path">
              <li><router-link to="/">Home</router-link></li>               
              <li v-if="status == 'payment-success'" class="active">Payment Successful</li>
              <li v-else class="active">Payment Failed</li>
          </ul>
        </div>
      </div>
   </section>
  <div v-if="status == 'payment-success'" class="container mt-5">
    <div class="row row-40 justify-content-center">         
      <div class="col-sm-10 col-md-6">
        <div class="success-card text-center">
          <div class="success-icon">
            <img src="/assets/images/success-icon.png" class="Sign-check-icon" alt="">
          </div>
          <h2 class="success-title">Payment Successful!</h2>
          <p class="success-message">
            Thank you for your payment. Your transaction has been completed successfully.
          </p>
          <p class="transaction-id text-muted">
            Transaction ID: <strong>#{{ transactionId }}</strong>
          </p>

          <router-link class="btn btn-home" to="/">
            <i class="bi bi-house-door"></i> Back to Home
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="container mt-5">
    <div class="row row-40 justify-content-center">         
      <div class="col-sm-10 col-md-6">
        <div class="success-card text-center">
          <div class="success-icon">
            <img src="/assets/images/error-icon.png" class="Sign-check-icon" alt="">
          </div>
          <h2 class="error-title">Payment Failed!</h2>
          <p class="success-message">
            Your payment has failed. Please try again.
          </p>          

          <router-link class="btn btn-home" to="/">
            <i class="bi bi-house-door"></i> Back to Home
          </router-link>
        </div>
      </div>
    </div>
  </div>   
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
const status = router.currentRoute.value.name
const transactionId = router.currentRoute.value.params.id

function goHome() {
  router.push('/') // redirect to home or dashboard
}
</script>

<style scoped>
.success-card {
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  padding: 40px 50px;
  animation: fadeInUp 0.8s ease-in-out;
}

.success-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;  
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.success-icon i {
  font-size: 40px;
  color: #198754;
}

.success-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #198754;
  margin-bottom: 10px;
}

.error-title{
  font-size: 1.8rem;
  font-weight: 600;
  color: #dc3545;
  margin-bottom: 10px;
}

.success-message {
  color: #6c757d;
  font-size: 1rem;
  margin-bottom: 10px;
}

.transaction-id {
  margin-bottom: 25px;
  font-size: 0.95rem;
}

.btn-home {
  background-color: #198754;
  border: none;
  color: #fff;
  padding: 10px 25px;
  border-radius: 50px;
  transition: all 0.3s ease;
}

.btn-home:hover {
  background-color: #157347;
  transform: translateY(-2px);
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
